import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import {
    fetchPaymentMethod,
    fetchPaymentMethodSuccess,
    fetchPaymentMethodFailure,
    getPaymentMethod,
    getPaymentMethodSuccess,
    getPaymentMethodFailure,
    updateUserPayout,
    updateUserPayoutSuccess,
    updateUserPayoutFailure
} from './payment-method.action';
import { of } from 'rxjs';
import { map, mergeMap, catchError, tap } from 'rxjs/operators';
import { PaymentMethodsService, PageService, UserService} from '@services/index';


@Injectable()
export class PaymentMethodEffects {
  loadPayments$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fetchPaymentMethod),
      mergeMap(action =>
        this.paymentMethodsService.getPaymentMethods().pipe( 
          map(res => {
            return fetchPaymentMethodSuccess({ payment: res });
          }),
          catchError(error => {
            return of(fetchPaymentMethodFailure({ error }));
          })
        )
      )
    )
  );

  getPayment$ = createEffect(() =>
    this.actions$.pipe(
      ofType(getPaymentMethod),
      mergeMap(action => 
        this.paymentMethodsService.getPaymentMethod(action.id).pipe(
          map(res => {
            return getPaymentMethodSuccess({ payment: res });
          }),
          catchError(error => {
            return of(getPaymentMethodFailure({ error }));
          })
        )
      )
    )
  );

  updateUserPayment$ = createEffect(() =>
  this.actions$.pipe(
    ofType(updateUserPayout),
    mergeMap(action =>
      this.paymentMethodsService.renewUserPayment(action.payMethod).pipe(
        map(payMethod => {
          return updateUserPayoutSuccess({ payMethod });
        }),
        tap(res => {
          this.pageService.onNotificationToggle({ show: true, error: false, message: 'Payout Updated Successfully!' });
          this.paymentMethodsService.fetchPaymentMethods();
          this.userService.dispatchUpdateProfile();
        }),
        catchError(error => {
          this.pageService.onNotificationToggle({ show: true, error: true, message: 'Something Went Wrong!' });
          return of(updateUserPayoutFailure({ error }));
        })
      )
    )
  )
);

  constructor(
    private actions$: Actions,
    private pageService: PageService,
    private paymentMethodsService: PaymentMethodsService,
    private userService: UserService
  ) {}
}
